import { isCommercial, offerTypeFromJsonQuery } from 'shared/common/packages/JsonQuery';
import { selectJsonQuery } from 'shared/map-search/selectors/results';
import type { TLiquiditySource } from 'shared/map-search/types/liquiditySource';
import type { IApplicationState } from 'shared/map-search/types/redux';

import type { TFeature } from '../../types/map';
import type { IConfig } from '@cian/config/shared';
import type { TDevice } from '@cian/utils';

type TGetLiquiditySourceParams = {
  deviceType: TDevice;
  state: IApplicationState;
  config: IConfig;
  feature: TFeature;
};

export function getLiquiditySourceParam(params: TGetLiquiditySourceParams) {
  const { deviceType, state, config, feature } = params;
  /**
   * @todo: удалить в CD-260062
   */
  const isEnabled = !!config.get<boolean>('auction.cpcEnabled');

  if (!isEnabled) {
    return '';
  }

  const isMobile = deviceType !== 'desktop';
  const jsonQuery = selectJsonQuery(state);

  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const isCommercialType = isCommercial(offerType);

  /**
   * Источник коммерческой выдачи будет обработан непосредственно в его мкс'ах.
   */
  if (isCommercialType) {
    return '';
  }

  const isPulsed = !!feature.properties?.isPulsedGlow;

  const liquiditySourceBase: TLiquiditySource = isMobile ? 'mobile-web_serp_map' : 'web_serp_map';
  const liquiditySource: TLiquiditySource = isPulsed ? `${liquiditySourceBase}_pulsed` : liquiditySourceBase;

  return `&liquiditySource=${encodeURIComponent(liquiditySource)}`;
}
